import { Outlet } from 'react-router-dom';
import { useTheme, Container, Box } from '@mui/material';

const AltLayout = () => {
    const theme = useTheme();
    
    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: theme.palette.background.default,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Container
                maxWidth="sm"
                disableGutters
                sx={{
                    flex: 1,
                    width: '100%',
                }}
            >
                <Outlet />
            </Container>
        </Box>
    );
};

export default AltLayout;
